import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";

import StockToolForm from "./stock-tool-form/StockToolForm";
import ProductStockInfo from "./product-stock-info/ProductStockInfo";
import ContactDetailsBox from "../contact-details-box/contactDetailsBox";

// Util
import getProductStockDetails from "../../utils/data/getProductStockDetails";
import { dispatchNewEvent } from "../../utils/analytics/trigger/analyticsTrigger";

// Styles
import styles from "./contact-us-product-stock-tool-solution.module.scss";

function ContactUsProductStockToolSolution({
  solution: { id, fields, buttonType, hierarchyPosition },
  className,
  contactMethods,
}) {
  const [productData, setProductData] = useState(null);

  useEffect(() => {
    dispatchNewEvent("dataStateChange", {
      action: "contactUsDecision",
      type: "productStockInformation|productStockInformationOutStock",
      isSolution: "0",
    });
  }, []);

  const handleSubmit = async (formData, onComplete) => {
    const productStockDataRes = await getProductStockDetails(formData.productCode);
    onComplete();
    if (productStockDataRes.productCode && productStockDataRes.estimatedDate) {
      dispatchNewEvent("dataStateChange", {
        action: "contactUsDecision",
        type: `problemsWithProduct|productStockInformationOutStock|${productStockDataRes.productCode}:${productStockDataRes.estimatedDate}`,
        isSolution: "1",
      });
    }
    setProductData(productStockDataRes);
  };

  const locationOnPage = hierarchyPosition.join(" | ");

  return (
    <article className={classnames(styles.productStockToolSolution, className)} data-solution-id={id}>
      {!productData?.customerDescription ? (
        <StockToolForm onSubmit={handleSubmit} noDetailsText={productData?.noDetailsText} />
      ) : (
        <>
          <ProductStockInfo productData={productData} />
          <div className={styles.contactDetailsBoxWrapper}>
            <ContactDetailsBox
              newDesign
              title="Did this answer your questions?"
              leftButtonText="No, I need help"
              rightButtonText="Yes, that‘s helpful"
              fields={fields.filter(({ name }) => ["phone", "chat", "email"].includes(name))}
              buttonType={buttonType}
              solutionId={id}
              location={locationOnPage}
              contactMethods={contactMethods}
            />
          </div>
        </>
      )}
    </article>
  );
}

ContactUsProductStockToolSolution.propTypes = {
  solution: PropTypes.shape({
    id: PropTypes.string,
    fields: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        content: PropTypes.string,
      }),
    ),
    buttonType: PropTypes.string,
    hierarchyPosition: PropTypes.arrayOf(PropTypes.string).isRequired,
  }).isRequired,
  className: PropTypes.string,
  contactMethods: PropTypes.shape({
    emailUs: PropTypes.arrayOf(PropTypes.string),
    liveChat: PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.shape({ name: PropTypes.string, pct: PropTypes.number })]),
    ),
    partnersLiveChat: PropTypes.arrayOf(PropTypes.string),
  }),
};

ContactUsProductStockToolSolution.defaultProps = {
  className: undefined,
  contactMethods: {},
};

export default ContactUsProductStockToolSolution;
